export default __webpack_public_path__ + "static/media/infographics_1.66248cec.jpg";